import FlagIconPath from "@ingka/ssr-icon/paths/flag";

export default FlagIconPath;
